import { LayoutGrid } from 'lucide-react'
import { useCallback, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router'

import { useHomeWidgets } from '@/components/home/use-home-widgets'
import { AccountMenu } from '@/components/shared/account-menu'
import { HamburgerMenu } from '@/components/shared/hamburger-menu'
import { HomeContent } from '@/components/shared/home-content'
import { HeaderImage } from '@/components/ui/icons'
import { PATHS } from '@/routes/paths'
import { useHomeLayoutStore } from '@/store/useHomeLayoutStore'

export const Home = () => {
  const navigate = useNavigate()
  const widgetData = useHomeWidgets()
  const isEditingLayout = useHomeLayoutStore((state) => state.isEditing)
  const setEditingLayout = useHomeLayoutStore((state) => state.setEditing)

  useEffect(() => {
    navigator.serviceWorker?.getRegistration().then((registration) => {
      registration?.update()
    })
  }, [])

  const handleNavigate = useCallback((path: string) => navigate(path), [navigate])

  const badges = useMemo(
    () =>
      new Map([
        [PATHS.TODO.HOME, widgetData.todos?.length ?? 0],
        [PATHS.ACTIVITY, widgetData.unreviewedDays ?? 0],
        [PATHS.RECEIPTS.LIST, widgetData.receiptPending ?? 0],
        [PATHS.LIBRARY.SEARCH, widgetData.libraryPickupReady ?? 0],
      ]),
    [widgetData.todos, widgetData.unreviewedDays, widgetData.receiptPending, widgetData.libraryPickupReady],
  )

  return (
    <div className="flex h-full w-full flex-col overflow-hidden select-none [-webkit-touch-callout:none]">
      <div className="relative h-20 w-full shrink-0 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <HeaderImage />
        </div>
        <div className="relative z-50 flex h-full items-center justify-between px-4 pb-2">
          <HamburgerMenu />
          <div className="flex items-center gap-3">
            {!isEditingLayout && (
              <button
                type="button"
                onClick={() => setEditingLayout(true)}
                aria-label="ホームを編集"
                className="flex size-8 items-center justify-center rounded-full border-none bg-black/30 text-white backdrop-blur active:opacity-70"
              >
                <LayoutGrid size={16} />
              </button>
            )}
            <AccountMenu />
          </div>
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto overscroll-none">
        <div className="mx-auto max-w-6xl pt-3 pb-8">
          <HomeContent onNavigate={handleNavigate} data={widgetData} badges={badges} />
        </div>
      </div>
    </div>
  )
}
